// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { testimonialsStyles } from "@tps/App/Widgets/Testimonials/Testimonials";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

testimonialsStyles.container = {
    css: css`
        background-color: ${color("primary")};
        padding: 32px 16px;
        display: flex;
        flex-direction: column;
        min-height: 265px;
        ${xScreen("lte", "md")} {
            padding-inline: 32px;
        }
    `,
};

testimonialsStyles.testimonialContainer = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-bottom: 34px;
    `,
};

testimonialsStyles.copyText = {
    variant: "p",
    color: "common.white",
    weight: "bold",
    css: css`
        margin-bottom: 0;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &::after {
            content: "";
            display: block;
            max-width: 240px;
            width: 100%;
            height: 1px;
            margin-top: 16px;
            margin-bottom: 16px;
            background: ${color("common.ui9")};
        }
    `,
};

testimonialsStyles.authorText = {
    size: "12px",
    lineHeight: "20px",
    color: "common.white",
    weight: fontConfig.weight.regular,
    css: css`
        letter-spacing: 0;
        display: flex;
    `,
};
